import React from "react";
import Navbar from 'react-bootstrap/Navbar';
import Container from 'react-bootstrap/Container';
import NavDropdown from 'react-bootstrap/NavDropdown';
import DealerSearch from "./DataExplorer/DealerLookup/DealerSearch"; // Ensure this path is correct
import { useLocation, useNavigate } from "react-router-dom";

function GlobalHeader({ username, onSearchSubmit, isNickLargent }) {
  const location = useLocation();
  const navigate = useNavigate();
  const showDealerSearch = location.pathname === "/";

  // Determine current page title
  let pageTitle = "Vehicle Data Explorer";
  if (location.pathname === "/group-search") pageTitle = "Group Search";
  if (location.pathname === "/test") pageTitle = "Smoke Tests";
  if (location.pathname === "/events") pageTitle = "Events";

  return (
    <Navbar bg="dark" variant="dark" expand="lg">
      <Container fluid>
        <div style={{display: 'flex', alignItems: 'center', gap: '8px', marginBottom: 0, paddingBottom: 0}}>
          <NavDropdown
            title={<span style={{fontSize: '1.25rem', fontWeight: 500, color: '#fff'}}>{pageTitle}</span>}
            id="main-tool-dropdown"
          >
            <NavDropdown.Item onClick={() => navigate("/")}>Vehicle Data Explorer</NavDropdown.Item>
            {isNickLargent && <NavDropdown.Item onClick={() => navigate("/test")}>Smoke Tests</NavDropdown.Item>}
            {isNickLargent && <NavDropdown.Item onClick={() => navigate("/events")}>Events</NavDropdown.Item>}
            <NavDropdown.Item onClick={() => navigate("/group-search")}>Group Search</NavDropdown.Item>
          </NavDropdown>

        </div>
        {showDealerSearch && <DealerSearch username={username} onSearchSubmit={onSearchSubmit} isNickLargent={isNickLargent} />}
        <Navbar.Text className="ms-3">Signed in as {username}</Navbar.Text>
      </Container>
    </Navbar>
  );
}

export default GlobalHeader;
